import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { confirmationAlert, showAlert } from '../../../utility/SweetAlert'

const InteractorFundBillCancel = () => {
  const { t } = useTranslation()
  const fundBillCancel = useCallback(
    (payload, loading, invoice_code) => {
      confirmationAlert({
        message: `${invoice_code} ${t('message.confirm_cancel_invoice')}`,
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/fund-bill/cancelled', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_updated'),
                timer: 1500,
                reload: true,
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { fundBillCancel }
}

export default InteractorFundBillCancel
